(function () {
    var self = {
        initHasData: function () {
            $.fn.hasData = function (key) {
                return (typeof $(this).data(key) != 'undefined');
            };
        },
        initDisable: function() {
            $.fn.disable = function () {
                $(this).prop('disabled', true).addClass("disabled");
            };
            $.fn.enable = function () {
                $(this).prop('disabled', false).removeClass("disabled");
            };
        },
        init: function () {
            self.initHasData();
            self.initDisable();
        }
    };
    try {
        self.init();
    } catch (e) {
        console.log(e);
    }

})(jQuery);